// 使用相对路径，跟随页面的协议(http/https)和域名，避免 HTTPS 下产生混合内容错误
const BASE_URL = '';

async function request<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE_URL}${url}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `请求失败: ${res.status}`);
  }
  return res.json();
}

// ==================== Agent API ====================

export interface AgentStartResult {
  threadId: string;
  message: string;
}

export interface AgentChatResult {
  message: string;
}

export interface MockAnswerResult {
  message: string;
}

// 启动 agent 会话
export function startAgent(): Promise<AgentStartResult> {
  return request<AgentStartResult>('/frontagent/api/agent/start', { method: 'POST' });
}

// 继续 agent 对话
export function chatWithAgent(threadId: string, message: string): Promise<AgentChatResult> {
  return request<AgentChatResult>('/frontagent/api/agent/chat', {
    method: 'POST',
    body: JSON.stringify({ thread_id: threadId, message }),
  });
}

// 模拟作答
export function mockAnswer(): Promise<MockAnswerResult> {
  return request<MockAnswerResult>('/frontagent/api/student/mockanswer', { method: 'GET' });
}

// 重置所有数据
export function resetAllData(threadId: string): Promise<{ message: string }> {
  return request<{ message: string }>('/frontagent/api/reset', { method: 'POST', body: JSON.stringify({ thread_id: threadId }) });
}
